export default "__VITE_ASSET__48607eab__"